export default {"src":"/_next/static/media/chevron-up.fb6a5060.svg","height":20,"width":20};